"use client";

import { useSyncExternalStore } from "react";
import { subscribeConnection, getConnectionSnapshot } from "@/lib/connection-status";

/**
 * True while the browser is online AND the app server is reachable.
 * Server snapshot is `true` so SSR/hydration never assume a lost connection.
 */
export function useConnectionUp(): boolean {
  return useSyncExternalStore(subscribeConnection, getConnectionSnapshot, () => true);
}
